import React from 'react';
import { Steps, Card, Typography, Tag, Divider, Carousel } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';

export default function StepPoints({listPoints}) {
  const { Step } = Steps;
  const { Title, Text } = Typography;

  const dateFormat = (date) => {
    if (!date) return "N/A";
    if (typeof date?.toDate === "function") {
      return date.toDate().toLocaleDateString("pt-BR");
    }
    if (typeof date === "string" && date.includes("-")) {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
    const parsed = new Date(date);
    return Number.isNaN(parsed.getTime()) ? "N/A" : parsed.toLocaleDateString("pt-BR");
  };

  return ( 
    
    <Steps direction="vertical" style={{ padding: '16px', backgroundColor: '#fff' }}>
    {listPoints.subcollectionData.map((data, index) => (
      
      <Step
        key={data.id}
        status={data.concluded ? "finish" : "process"}

        icon={data.concluded ? 
          <CheckCircleOutlined style={{ color: 'green' }} />
        :
          <ClockCircleOutlined style={{ color: 'gray' }} />
        } // Ícone customizado

        title={<div style={{ display: "flex", alignItems: "center", gap: 10, paddingBottom: 8 }}>
          <Title level={5} style={{ margin: 0 }}>
            Parada {data.stop_order}: {data.name}
          </Title>
          <Tag color={data.concluded ? "green" : "orange"} style={{ margin: 0 }}>
            {data.concluded ? "Concluida" : "Pendente"}
          </Tag>
        </div>}
        description={
          <Card
            bordered={false}
            style={{
              backgroundColor: '#ffffff',
              padding: '12px',
              borderRadius: '10px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <div
              style={{
                marginBottom: 12,
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: "10px 12px",
                background: "#f8fafc",
              }}
            >
              <div style={{ marginBottom: 8 }}>
                <Text strong>Endereco:</Text>{" "}
                {`${data.logradouro || "Nao informado"}, ${data.number || "S/N"}`}
              </div>
              <div style={{ marginBottom: 8 }}>
                <Text strong>Cidade:</Text> {data.city || "Nao informado"}, <Text strong>UF:</Text> {data.uf || "N/A"}
              </div>
              <div>
                <Text strong>CEP:</Text> {data.cep || "Nao informado"}
              </div>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <Text strong>Data Finalizacao:</Text> {dateFormat(data?.date_operation)}
            </div>
            <div style={{ marginBottom: '12px' }}>
              {data.canhoto ? (

                <a 
                  href={data.canhoto} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img 
                    src={data.canhoto} 
                    alt="Canhoto" 
                    style={{ 
                      width: "130px",
                      height: "130px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      transition: "all 0.3s ease"
                    }}
                  />
                </a>
              ) : (
                <Tag color="default">Canhoto nao encontrado</Tag>
              )}
            </div>
            <div style={{ marginBottom: '12px' }}>
              <Text strong>Coordenadas:</Text>{' '}
              <a
                href={`https://www.google.com/maps/dir/${data.latitude},${data.longitude}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1890ff' }}
              >
                {data.latitude}, {data.longitude}
              </a>
            </div>
            <Divider />
            {data?.events?.length > 0 ? (
              <>
                <Title level={5} style={{ marginBottom: 10 }}>Ocorrencias ({data.events.length})</Title>
                <ul style={{ paddingLeft: '20px' }}>
                  {data.events.map((event, idx) => (
                    <li key={idx} style={{ marginBottom: '12px', border: "1px solid #e5e7eb", borderRadius: 8, padding: 10, listStyle: "none" }}>
                      <Text>
                        <Text strong>Registrado em:</Text>{' '}
                        {event?.created_at && typeof event.created_at.seconds === 'number'
                          ? new Date(event.created_at.seconds * 1000).toLocaleString()
                          : 'Data inválida'}
                      </Text>
                      <br />
                      <Text>
                        <Text strong>Evento:</Text> Codigo: {event?.event?.cod || ''} -{' '}
                        {event?.event?.desc || ''}
                      </Text>
                      <br />
                      <Text>
                        <Text strong>Descrição:</Text> {event?.description || ''}
                      </Text>
                      <br />
                      <Carousel autoplay>
                        {(event?.images || []).map((img, imgIdx) => (
                          <div 
                            key={imgIdx} 
                            style={{ 
                              width: "130px", 
                              height: "130px", 
                              display: "flex", 
                              justifyContent: "center", 
                              alignItems: "center" 
                            }}
                          >
                            <a 
                              href={img} 
                              target="_blank" 
                              rel="noopener noreferrer"
                            >
                              <img
                                src={img}
                                alt="Evento"
                                style={{
                                  width: "130px", 
                                  height: "130px", 
                                  borderRadius: "5px",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease"
                                }}
                              />
                            </a>
                          </div>
                        ))}
                      </Carousel>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <Tag color="blue">Sem eventos</Tag>
            )}
          </Card>
        }
      />
    ))}
  </Steps>

  );
}
